module.exports = __webpack_public_path__ + "img/Kf.ce0eb762.png";